import { render } from "./CRMWhatsappContactFilesDialog.vue?vue&type=template&id=ce4c953c"
import script from "./CRMWhatsappContactFilesDialog.vue?vue&type=script&lang=js"
export * from "./CRMWhatsappContactFilesDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__